import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '../auth/AuthContext';
import './Navbar.css';
import logo from '../assets/puntology_logo.png';

function Navbar() {
  const { isAuthenticated, loading } = useAuth();
  const [isOpen, setIsOpen] = useState(false);
  const [activeDropdown, setActiveDropdown] = useState(null);
  const [isMobile] = useState(window.innerWidth <= 768);

  if (loading) {
    return null;
  }

  const toggleMenu = () => {
    setIsOpen(!isOpen);
    setActiveDropdown(null);
  };

  const closeMenu = () => {
    setIsOpen(false);
    setActiveDropdown(null);
  };

  const toggleDropdown = (dropdownName) => {
    if (window.innerWidth <= 768) {
      setActiveDropdown(activeDropdown === dropdownName ? null : dropdownName);
    }
  };

  const handleDropdownClick = (e, dropdownName) => {
    if (window.innerWidth <= 768) {
      e.preventDefault();
      toggleDropdown(dropdownName);
    }
  };

  return (
    <nav className="navbar">
      <Link to="/" className="logo" onClick={closeMenu}>
        <img src={logo} alt="Puntology" className="logo-image" />
      </Link>

      <div className="mobile-menu-button" onClick={toggleMenu}>
        <span className={isOpen ? 'spanOpen' : ''}></span>
        <span className={isOpen ? 'spanOpen' : ''}></span>
        <span className={isOpen ? 'spanOpen' : ''}></span>
      </div>

      <div className={`nav-buttons ${isOpen ? 'active' : ''}`}>
        <div
          className={`nav-button dropdown`}
          onClick={(e) => handleDropdownClick(e, 'tools')}
        >
          <span>Tools</span>
          <div className={`dropdown-content ${activeDropdown === 'tools' ? 'active' : ''}`}>
            <Link to="/back-lay" className="dropdown-item" onClick={closeMenu}>Back/Lay</Link>
            <Link to="/dutching" className="dropdown-item" onClick={closeMenu}>Dutching</Link>
          </div>
        </div>

        {isAuthenticated ? (
          <>
            {/* Add other authenticated nav items here */}
            {isMobile && (
              <Link to="/settings" className="nav-button" onClick={closeMenu}>
                Settings
              </Link>
            )}
          </>
        ) : (
          <>
            <Link to="https://www.instagram.com/puntology.aus/" className="nav-button" onClick={closeMenu}>Instagram</Link>     
            <Link to="/login" className="nav-button" onClick={closeMenu}>Log In</Link>
            <Link to="/signup" className="nav-button" onClick={closeMenu}>Sign Up</Link>
          </>
        )}
      </div>

      {isAuthenticated && !isMobile && (
        <Link to="/settings" className="settings-button">
          <i className="fas fa-gear"></i>
        </Link>
      )}
    </nav>
  );
}

export default Navbar;